import type React from "react";
import { Box } from "@mui/material";

interface NewFeatureBadgeProps {
  children: React.ReactNode;
  label?: string;
}

/**
 * Wraps any element (typically a Button) with a small "NEW" pill badge
 * pinned to its top-right corner. Use to flag recently added features.
 */
const NewFeatureBadge: React.FC<NewFeatureBadgeProps> = ({
  children,
  label = "NEW",
}) => {
  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      {children}
      <Box
        component="span"
        sx={{
          position: "absolute",
          top: -8,
          right: -8,
          backgroundColor: "#FF3B30",
          color: "#fff",
          fontSize: 9,
          fontWeight: 700,
          letterSpacing: "0.03em",
          borderRadius: "999px",
          px: 0.75,
          py: 0.25,
          lineHeight: 1.4,
          pointerEvents: "none",
          boxShadow: "0 1px 3px rgba(0,0,0,0.25)",
          zIndex: 1,
        }}
      >
        {label}
      </Box>
    </Box>
  );
};

export default NewFeatureBadge;
